<!-- IMAGE -->
@if (data().type === 'image') { @if (data().url) {
<img class="content-data-viewer__image" [src]="data().url!" alt="Result image" />
} @else {
<div class="d-flex align-items-center gap-2 py-2 text-body-secondary">
  <mat-icon>image</mat-icon>
  Image too large to preview
</div>
} }

<!-- GEOTIFF — canvas preview with viridis colormap -->
@if (data().type === 'geotiff') {
<div class="d-flex flex-column gap-2">
  @if (tiffRenderError()) {
    <div class="d-flex align-items-center gap-2 py-2 text-body-secondary">
      <mat-icon>error_outline</mat-icon>
      {{ tiffRenderError() }}
    </div>
  } @else {
    <div class="content-data-viewer__tiff-wrap">
      <canvas #tiffCanvas [class.invisible]="isRenderingTiff()" class="content-data-viewer__tiff-canvas"></canvas>
      @if (isRenderingTiff()) {
        <div class="content-data-viewer__tiff-spinner d-flex align-items-center justify-content-center">
          <mat-progress-spinner diameter="32" mode="indeterminate" />
        </div>
      }
    </div>
  }
</div>
}

<!-- PDF — no inline preview -->
@if (data().type === 'pdf') {
<div class="d-flex align-items-center gap-2 py-2 text-body-secondary">
  <mat-icon>picture_as_pdf</mat-icon>
  PDF document
</div>
}

<!-- GEOJSON -->
@if (data().type === 'geojson') {
<div class="d-flex flex-column gap-2">
  @if (data().isTruncated) {
  <span class="d-flex align-items-center gap-1 small text-body-secondary">
    <mat-icon class="mat-icon-xs">info</mat-icon>
    Preview truncated — download for full data
  </span>
  } @if (data().geojson && !data().isTruncated) {
  <div class="content-data-viewer__json-wrap mat-font-body-md">
    <andypf-json-viewer theme="material-lighter" [data]="data().geojson" indent="2" [expanded]="expanded()" show-toolbar="false" show-size="true"></andypf-json-viewer>
  </div>
  }
</div>
}

<!-- JSON (generic) -->
@if (data().type === 'json') { @if (data().isTruncated) {
<div class="d-flex align-items-center gap-2 py-2 text-body-secondary">
  <mat-icon>data_object</mat-icon>
  Response too large to preview
</div>
} @else if (data().json) {
<div class="content-data-viewer__json-wrap mat-font-body-md">
  <andypf-json-viewer theme="material-lighter" [data]="data().json" indent="2" [expanded]="expanded()" show-toolbar="false" show-size="true"></andypf-json-viewer>
</div>
} }

<!-- TEXT -->
@if (data().type === 'text') { @if (data().isTruncated) {
<div class="d-flex align-items-center gap-2 py-2 text-body-secondary">
  <mat-icon>description</mat-icon>
  Response too large to preview
</div>
} @else if (data().text) {
<pre class="content-data-viewer__text">{{ data().text }}</pre>
} }

<!-- URL — render as styled surface box with external link -->
@if (data().type === 'url' && data().url) {
<a [href]="data().url" target="_blank" rel="noopener noreferrer"
   class="content-data-viewer__url-box d-flex align-items-start gap-2">
  <mat-icon class="mat-icon-sm mat-text-on-surface-variant flex-shrink-0" style="margin-top: 2px">open_in_new</mat-icon>
  <span class="mat-font-body-sm">{{ data().url }}</span>
</a>
}

<!-- BINARY / ZIP / UNKNOWN -->
@if (data().type === 'binary' || data().type === 'zip' || data().type === 'unknown') {
<div class="d-flex align-items-center gap-2 py-2 text-body-secondary">
  <mat-icon>folder_zip</mat-icon>
  <span>Binary data</span>
</div>
}
